import { render, staticRenderFns } from "./iconPhoto.vue?vue&type=template&id=b1370358"
import script from "./iconPhoto.vue?vue&type=script&lang=js"
export * from "./iconPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports